import React, { useEffect, useRef } from "react";
import { useCountUp } from "react-countup";

export const CounterPreview = (props) => {
    const countUpRef = useRef(null);

    // Inicializamos el hook y obtenemos el método `start`
    const { start } = useCountUp({
        ref: countUpRef,
        start: (props.startWithGap==="Y" ? (props.end * props.gapStart) : props.start) ,
        end: props.end,
        duration: props.duration,
        separator:props.thousandsSeparator,
        decimals:props.decimals,
        decimal:props.decimalsSeparator,
        suffix: props.suffix,

    });


    useEffect(() => {
        const timer = setTimeout(() => {
            start();
        }, props.delay);

        return () => clearTimeout(timer); // Limpiamos el timeout al desmontar
    }, [start]);

    return (
        <div>
            <div ref={countUpRef}
                 style={{
                     fontSize: props.fontSize,
                     color: '#' + (props.color).toString("#",""),
                     fontFamily: props.fontFamily,
                     fontWeight: "bold"
                 }}
            />
        </div>
    );
};
